import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Booking        from './Page/Booking';
import Dashboard      from './Page/Dashboard';
import Exhibitors     from './Page/Exhibitors';
import Tickets        from './Page/Tickets';
import WebsiteContent from './Page/WebsiteContent';
import PopupAds       from './Page/PopupAds';
import UsersRoles     from './Page/UsersRoles';
import EventSettings  from './Page/EventSettings';

/* 
  Pages not yet built — redirect to dashboard for now:
  /faq, /media, /analytics
  Add their components here when ready.
*/

const Routess = () => (
  <BrowserRouter>
    <Routes>
      
      <Route path='/'                element={<Navigate to='/dashboard' replace />} />

      <Route path='/dashboard'       element={<Dashboard />}      />
      <Route path='/bookings'        element={<Booking />}        />
      <Route path='/exhibitors'      element={<Exhibitors />}     />
      <Route path='/tickets'         element={<Tickets />}        />
      <Route path='/website-content' element={<WebsiteContent />} />
      <Route path='/popup-ads'       element={<PopupAds />}       />
      <Route path='/users'           element={<UsersRoles />}     />  {/* access denied */}
      <Route path='/settings'        element={<EventSettings />}  />

      
      <Route path='/faq'             element={<Navigate to='/dashboard' replace />} />
      <Route path='/media'           element={<Navigate to='/dashboard' replace />} />
      <Route path='/analytics'       element={<Navigate to='/dashboard' replace />} />

     
      <Route path='*'                element={<Navigate to='/dashboard' replace />} />
    </Routes>
  </BrowserRouter>
);

export default Routess;